import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StudentStatisticInterface} from '@interfaces/studentStatistic.interface';
import {StudentService} from '@services/student/student.service';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';

@Component({
  selector: 'app-student-statistic-widget',
  templateUrl: './student-statistic-widget.component.html',
  styleUrls: ['./student-statistic-widget.component.scss']
})
export class StudentStatisticWidgetComponent implements OnInit {
  studentStatistic: StudentStatisticInterface = {
    total: 0,
    active: 0,
    paused: 0,
    on_trial: 0,
    not_joined: 0,
    non_payer: 0,
    suspended: 0,
    no_show: 0,
    cancelled: 0,
  } as StudentStatisticInterface;
  subscribes = [];
  user;
  private statisticSchoolId;

  constructor(
   private router: Router,
   private authStore: Store<AuthReducer.AuthState>,
   private studentService: StudentService,
  ) {
  }
  ngOnInit() {
    this.subscribes.push(this.authStore.subscribe(
      (val) => {
        if (val.auth && val.auth.user) {
          this.user = val.auth.user;
          this.loadStudentStatistic(this.user.activeSchool);
        }
      }
    ));
  }

  private loadStudentStatistic(activeSchool) {
    if (!activeSchool || this.statisticSchoolId === activeSchool) {
      return;
    }
    this.statisticSchoolId = activeSchool;

    this.studentService
      .getStudentStatisticBySchool(activeSchool)
      .subscribe((resp: {data: StudentStatisticInterface}) => {
        this.studentStatistic = this.normaliseStatistic(resp.data);
      });
  }

  private normaliseStatistic(statistic: StudentStatisticInterface): StudentStatisticInterface {
    const source: any = statistic || {};
    return {
      total: Number(source.total) || 0,
      active: Number(source.active) || 0,
      paused: Number(source.paused) || 0,
      on_trial: Number(source.on_trial) || 0,
      not_joined: Number(source.not_joined) || 0,
      non_payer: Number(source.non_payer) || 0,
      suspended: Number(source.suspended) || 0,
      no_show: Number(source.no_show) || 0,
      cancelled: Number(source.cancelled) || 0,
    } as StudentStatisticInterface;
  }
}
